import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
} from "@material-ui/core";
import {
  AccountCircle,
  Add as AddIcon,
  Refresh as RefreshIcon,
} from "@material-ui/icons";
import useDashboardSectionStyles from "./useDashboardSectionStyles"; // Reuse styles if applicable
import ContextualCreditsDisplay from "./ContextualCreditsDisplay";
import { useAuth } from "../util/auth"; // Needed for fallback email

function WelcomeCard({ formData, onStartNew, onContinueEditing }) {
  const classes = useDashboardSectionStyles(); // Or create specific styles
  const auth = useAuth(); // Get auth info

  const firstName = formData?.personalInformation?.firstName;
  const userEmailPrefix = auth.user?.email?.split("@")[0];
  const welcomeName = firstName
    ? `, ${firstName}`
    : userEmailPrefix
    ? `, ${userEmailPrefix}`
    : "";

  return (
    <Card className={classes.welcomeCard} elevation={2}>
      <CardContent className={classes.welcomeCardContent}>
        <Box display="flex" alignItems="center" mb={2}>
          <Avatar className={classes.avatarLarge}>
            {firstName ? firstName.charAt(0).toUpperCase() : <AccountCircle />}
          </Avatar>
          <Box ml={2}>
            <Typography variant="h5" className={classes.welcomeTextLarge}>
              Welcome to your Dashboard{welcomeName}
            </Typography>
          </Box>
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Box>
            <Button
              variant="contained"
              color="primary"
              className={classes.actionButton}
              startIcon={<AddIcon />}
              onClick={onStartNew}
            >
              Create New Resume
            </Button>

            {formData && (
              <Button
                variant="outlined"
                color="primary"
                className={classes.actionButton}
                startIcon={<RefreshIcon />}
                onClick={onContinueEditing}
                style={{ marginLeft: "8px" }}
              >
                Continue Editing
              </Button>
            )}
          </Box>
          <Box>
            {/* Pass formData to ContextualCreditsDisplay */}
            <ContextualCreditsDisplay
              showUpgradePrompt={true}
              formData={formData}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default WelcomeCard;
